export default "__VITE_ASSET__DuNzpAX2__"